<template>
    <div>
        <products />
    </div>
</template>

<script>
    import Products from '../components/Category/Products'
    import {mapGetters, mapActions} from 'vuex'

    export default {
        name: 'CategoryPage',
        metaInfo () {
            return {
                title: this.currentCategory ? this.currentCategory.name : 'Čepro',
            }
        },
        watch: {
            loadingCategories: function (newValue) {
                if (!newValue) {
                    if (this.$router.currentRoute.name === 'Homepage') {
                        this.changeCategory('10b28b51-36a0-4133-811e-467d098c2c83');
                    } else {
                        this.changeCategory();
                    }
                }
            }
        },
        mounted() {
            if (this.$router.currentRoute.name === 'Homepage') {
                this.changeCategory('10b28b51-36a0-4133-811e-467d098c2c83');
            } else {
                this.changeCategory();
            }
        },
        components: {
            Products
        },
        computed: {
            ...mapGetters([
                'allProducts',
                'currentCategory',
                'loadingCategories'
            ])
        },
        methods: {
            ...mapActions([
                'changeCategory'
            ])
        }
    }
</script>
